import {ColumnProps} from "antd/lib/table";
import {TableType} from "./AttendanceListColumns";

export const getColumnsToShow = (
    columns: Array<{dataIndex: string} & TableType>,
    columnsToShow: Array<Extract<keyof TableType, string>>,
) => {
    const shownColumns: Array<ColumnProps<TableType>> = [];

    columns.forEach((col) => {
        if (columnsToShow.some((value) => value === col.dataIndex)) {
            shownColumns.push(col);
        }
    });

    moveLeftAligndColumnToFirstPosition(shownColumns);
    moveActionColumnToLastPosition(shownColumns);
    moveRowIndexToFirstPosition(shownColumns);

    return shownColumns;
};

export const moveActionColumnToLastPosition = (
    shownColumns: Array<ColumnProps<TableType>>,
) => {
    shownColumns.forEach((col) => {
        if (col.fixed === "right") {
            shownColumns.push(
                shownColumns.splice(shownColumns.indexOf(col), 1)[0],
            );
        }
    });
};

export const moveLeftAligndColumnToFirstPosition = (
    shownColumns: Array<ColumnProps<TableType>>,
) => {
    // Sammle alle left-aligned Spalten in ihrer ursprünglichen Reihenfolge
    const leftAlignedColumns: Array<ColumnProps<TableType>> = [];

    // Iteriere rückwärts, um die Indizes beim Entfernen nicht zu verschieben
    for (let i = shownColumns.length - 1; i >= 0; i--) {
        const col = shownColumns[i];

        if (col.fixed === "left") {
            // Entferne die Spalte und füge sie am Anfang der leftAlignedColumns hinzu
            leftAlignedColumns.unshift(shownColumns.splice(i, 1)[0]);
        }
    }

    // Füge alle left-aligned Spalten in der richtigen Reihenfolge am Anfang ein
    shownColumns.unshift(...leftAlignedColumns);
};

export const moveRowIndexToFirstPosition = (
    shownColumns: Array<ColumnProps<TableType>>,
) => {
    shownColumns.forEach((col) => {
        if (col.dataIndex === "rowIndex") {
            shownColumns.unshift(
                shownColumns.splice(shownColumns.indexOf(col), 1)[0],
            );
        }
    });
};
